export const USER_LOGGED_IN = "USER_LOGGED_IN";
export const USER_LOGGED_OUT = "USER_LOGGED_OUT";
export const EVENT_SELECT = "EVENT_SELECT"
export const SCHEDULE_SELECT = "SCHEDULE_SELECT"